import React from "react";
import AutoTyping from "react-auto-typing";
import { Dots } from "react-dot-patterns";

const OurApproach = () => {
  return (
    <div className="on-service-approach-wrapper">
      <div className="dots1">
        <Dots
          col={6}
          row={4}
          size={5}
          rotate={0}
          margin={8}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={10}
          // evenColoumnShift={20}
        />
      </div>
      <div className="dots2">
        <Dots
          col={3}
          row={4}
          size={5}
          rotate={0}
          margin={5}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={-20}
          // evenColoumnShift={20}
        />
      </div>
      <div className="section-title">
        <h1 className="title">Adaptive, Proactive and Scalable</h1>
        <span className="subtitle" aria-hidden="true">
          <AutoTyping
            active // <boolean>
            textRef={"Our Approach"}
            writeSpeed={150} // <number>
            deleteSpeed={150} // <number>
            delayToWrite={1000} // <number>
            delayToDelete={2000}
          />
        </span>
      </div>
      <div className="approach-container">
        <div className="approach-box">
          <div className="approach-detail first">
            <div className="arrow"></div>
            <h4>Strategy</h4>
            <p>
              Helping you answer the question, "What exactly should I build?"
            </p>
          </div>
        </div>
        <div className="approach-box">
          <div className="approach-detail second">
            <div className="arrow"></div>
            <h4>Design</h4>
            <p>
              Creating beautiful, easy-to-use interfaces taht delight users and
              make your company look great.
            </p>
          </div>
        </div>
        <div className="approach-box">
          <div className="approach-detail third">
            <div className="arrow"></div>
            <h4>Development</h4>
            <p>
              Writing bullet-proof code that runs smoothly and securely accross
              multiple platforms.
            </p>
          </div>
        </div>
        <div className="approach-box">
          <div className="approach-detail forth">
            <div className="arrow"></div>
            <h4>Deployment</h4>
            <p>Getting your product to people with minimum hassle.</p>
          </div>
        </div>
        <div className="approach-box">
          <div className="approach-detail fifth">
            <div className="arrow"></div>
            <h4>Maintenance</h4>
            <p>
              Keeping your product in top shape with block-of-time support
              contracts so we can respond quickly to your needs.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurApproach;
